import { render } from "./LoginPage.vue?vue&type=template&id=e778d9fa"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=e778d9fa&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__